export const defaultCrop = Object.freeze({ x: 50, y: 50, zoom: 1 });

export function normalizeCrop(value) {
  const x = Number(value?.x);
  const y = Number(value?.y);
  const zoom = Number(value?.zoom);
  return {
    x: Number.isFinite(x) ? Math.min(100, Math.max(0, x)) : defaultCrop.x,
    y: Number.isFinite(y) ? Math.min(100, Math.max(0, y)) : defaultCrop.y,
    zoom: Number.isFinite(zoom) ? Math.min(3, Math.max(1, zoom)) : defaultCrop.zoom,
  };
}

export function cropStyle(value) {
  const crop = normalizeCrop(value);
  return {
    objectPosition: `${crop.x}% ${crop.y}%`,
    transform: `scale(${crop.zoom})`,
    transformOrigin: `${crop.x}% ${crop.y}%`,
  };
}
